import isUndefined from "lodash/fp/isUndefined";
import constants from "../../core/constants";
class Controller {
  constructor($injector, $stateParams, Sections) {
    "ngInject";
    this.$injector = $injector;
    this.$stateParams = $stateParams;
    this.sections = Sections.settingsSections;
    this.Events = $injector.get("Events");
    this.Pricings = $injector.get("PrivateBusPricing");
    this.onUpdate = this.Events.getUpdateEvent("PrivateBusPricing");
    this.PricingTransforms = $injector.get("PricingTransforms");
  }

  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const onUpdate = (item) => {
      const updatedItem = {};
      if (
        item.key === "one_way_pricing" ||
        item.key === "on_another_day_pricing" ||
        item.key === "on_same_day_pricing"
      ) {
        item.value *= constants.currencyBy;
      }
      if (item.key === "one_day_span") {
        item.value *= constants.fromHourToMilli;
      }

      updatedItem[item.key] = isUndefined(item.value)
        ? item.name
          ? item.name._id
          : null
        : item.value;
      this.Pricings.updateItem(this.$stateParams.id, updatedItem).$promise.then(
        (response) => {
          this.pricing = this.PricingTransforms.justify(response);
          this.Events.emit(showNotificationEvent, {
            message: "Pricing updated sucessfully",
          });
        },
        (response) => {
          this.Events.emit(errorEvent, response.data);
        }
      );
    };
    this.Pricings.get(this.$stateParams.id).$promise.then((response) => {
      this.pricing = this.PricingTransforms.justify(response);
    });
    this.Events.on(this.onUpdate, onUpdate);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/pricing/pricing.controller.js